import { PLATFORM_ORG_ID } from 'domains/orgDomain';
import { Paged } from 'domains/appDomain';
import { ListParcelParam, Parcel, PartialParcel } from 'domains/parcelDomain';
import api from 'utils/api';

const parcelService = {
  getPagedParcels: async (param: ListParcelParam) => {
    return api.post<Paged<Parcel>>(
      `/api/parcels/list?size=${param.page.pageSize}&page=${
        param.page.currentPage - 1
      }`,
      param.query
    );
  },

  getPagedBaseParcels: async (param: ListParcelParam) => {
    return api.post<Paged<Parcel>>(
      `/api/parcels/list?size=${param.page.pageSize}&page=${
        param.page.currentPage - 1
      }`,
      param.query,
      {
        'x-tenant-id': PLATFORM_ORG_ID,
      }
    );
  },

  addParcel: async (parcel: PartialParcel) => {
    return api.post(`/api/parcels`, {
      ...parcel,
    });
  },

  updateParcel: async (parcel: PartialParcel) => {
    return api.put(`/api/parcels/${parcel.id}`, parcel);
  },

  deleteParcel: async (parcel: PartialParcel) => {
    return api.delete(`/api/parcels/${parcel.id}`);
  },
};
export default parcelService;
